<template>
  <div>
    <div class="pl-2">
      <FiltroPendentes />
    </div>
  </div>
</template>

<script>
  //Components
  import FiltroPendentes from "../../../Filtros/FiltroPendentes"

  export default {
    name: "FiltrosCheckPoints",
    components: {
      FiltroPendentes,
    }
  }
</script>

<style scoped>
 
</style>